import React from 'react';
import { ChatBot } from './components/chatbot';

function App() {
  return <ChatBot />;
}

export default App;
